/// <reference types="vite-plugin-pwa/client" />
import { registerSW } from 'virtual:pwa-register';

/**
 * Registers the service worker. Called once from main.ts.
 *
 * The first online visit primes the cache; subsequent visits work offline
 * because workbox's precache covers the app shell, locale JSONs (inlined
 * as data URLs in the main bundle), the blue-noise tile, the manifest,
 * and the PWA icons. The error-diffusion worker is NOT in the precache
 * for v0.1.0 - the demo runs error diffusion on the main thread; Phase 1
 * will publish the worker as a subpath export and wire it through here.
 *
 * On iPadOS / iOS Safari the precache may be evicted under storage
 * pressure or extended non-use. The hosted PWA is offline-capable but not
 * offline-guaranteed; the Phase 1 Tauri bundle covers the offline-required case.
 */
export function registerServiceWorker(): void {
  if (typeof window === 'undefined') return;
  registerSW({
    immediate: true,
    onOfflineReady() {
      console.info('[pwa] ready for offline use');
    },
    onNeedRefresh() {
      console.info('[pwa] new content available, refresh to update');
    },
  });
}
